<template>
  <TableLayout :permissions="['business:identityinfo:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="身份类型" prop="type">
        <el-select v-model="searchForm.type" clearable placeholder="请选择身份类型" @change="search">
          <el-option :value="0" label="用工身份"></el-option>
          <el-option :value="1" label="货运身份"></el-option>
          <el-option :value="2" label="供餐身份"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="认证类型 " prop="authType">
        <el-select v-model="searchForm.authType" clearable placeholder="请选择认证类型" @change="search">
          <el-option :value="0" label="个人"></el-option>
          <el-option :value="1" label="企业"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人" prop="linkName">
        <el-input v-model="searchForm.linkName" placeholder="请输入联系人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="telephone">
        <el-input v-model="searchForm.telephone" placeholder="请输入联系方式" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="接单位置" prop="location">
        <el-input v-model="searchForm.location" placeholder="请输入接单位置" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="单位名称" prop="companyName">
        <el-input v-model="searchForm.companyName" placeholder="请输入单位名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
        <el-button type="primary" :loading="isWorking.export" @click="exportExcel">导出</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
<!--      <ul class="toolbar" v-permissions="['business:identityinfo:create', 'business:identityinfo:delete']">
        <li><el-button type="primary" @click="$refs.operaIdentityInfoWindow.open('新建会员身份认证信息表')" icon="el-icon-plus" v-permissions="['business:identityinfo:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:identityinfo:delete']">删除</el-button></li>
      </ul>-->
      <el-table
          :height="tableHeightNew"
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="auditStatus" label="审核状态" min-width="100px" fixed="left">
          <template slot-scope="{row}">
            <span class="bluestate" v-if="row.auditStatus ==1">申请中</span>
            <span class="greenstate" v-if="row.auditStatus ==2">已通过</span>
            <span class="redstate" v-if="row.auditStatus ==3">未通过</span>
          </template>
        </el-table-column>
        <el-table-column prop="openid" label="openid" min-width="180px"  :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="memberName" label="会员昵称" min-width="100px" :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="type" label="类型" min-width="100px">
          <template slot-scope="{row}">
           <span v-if="row.type ==0">用工身份</span>
           <span v-if="row.type ==1">货运身份</span>
           <span v-if="row.type ==2">供餐身份</span>
          </template>
        </el-table-column>
        <el-table-column prop="authType" label="认证类型" min-width="100px">
          <template slot-scope="{row}">
            <span v-if="row.authType ==0">个人</span>
            <span v-if="row.authType ==1">企业</span>
          </template>
        </el-table-column>
        <el-table-column prop="linkName" label="联系人" min-width="100px" :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="telephone" label="联系方式" min-width="100px" :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="location" label="接单位置" min-width="180px"  :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="companyName" label="单位名称" min-width="150px"  :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="createTime" label="申请时间" min-width="150px"></el-table-column>
        <el-table-column prop="editorName" label="审核人" min-width="100px" :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="auditTime" label="认证审批时间" min-width="150px"></el-table-column>
        <el-table-column prop="auditRemark" label="认证审批备注" min-width="120px"  :show-overflow-tooltip='true'></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:identityinfo:update','business:identityinfo:query'])"
          label="操作"
          min-width="160"
          fixed="right"
        >
        <template slot-scope="{row}">
            <el-button type="text" v-if="row.auditStatus==1" @click="$refs.OperaIdentityDetailWindow.open('用户认证审核', row)" icon="el-icon-edit" v-permissions="['business:identityinfo:update']">审核</el-button>
            <el-button type="text"  @click="$refs.OperaIdentityDetailWindow.open('用户认证详情', row)" icon="el-icon-info" >详情</el-button>
<!--
            <el-button type="text" @click="$refs.operaIdentityInfoWindow.open('编辑会员身份认证信息表', row)" icon="el-icon-edit" v-permissions="['business:identityinfo:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:identityinfo:delete']">删除</el-button>
-->
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaIdentityDetailWindow ref="OperaIdentityDetailWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaIdentityDetailWindow from '@/components/business/OperaIdentityDetailWindow'
export default {
  name: 'IdentityInfo',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaIdentityDetailWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        deleted: '',
        createUser: '',
        createTime: '',
        updateUser: '',
        updateTime: '',
        remark: '',
        type: '',
        memberId: '',
        authType: '',
        linkName: '',
        telephone: '',
        location: '',
        companyName: '',
        lat: '',
        lgt: '',
        identityFront: '',
        identityBack: '',
        businessLicense: '',
        otherFile: '',
        transportFile: '',
        foodBusinessFile: '',
        healthFile: '',
        auditStatus: '',
        auditTime: '',
        auditRemark: ''
      }
    }
  },
  created () {
    this.config({
      module: '会员身份认证信息表',
      api: '/business/identityInfo',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
